"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Button_1 = require("@material-ui/core/Button");
var Theme_1 = require("./Theme");
var FormControlButtonSwitch = /** @class */ (function (_super) {
    __extends(FormControlButtonSwitch, _super);
    function FormControlButtonSwitch(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            value: props.value || props.options[0]
        };
        _this.onClick = _this.onClick.bind(_this);
        return _this;
    }
    FormControlButtonSwitch.prototype.render = function () {
        var _this = this;
        return (React.createElement(Theme_1.default, { color: "default" },
            React.createElement("div", { className: "button-switch" }, this.props.options.map(function (option) {
                return React.createElement("div", { className: "button-switch-button", key: option.value },
                    React.createElement(Button_1.default, { fullWidth: true, style: { height: "100%" }, variant: _this.state.value.value === option.value ? "contained" : "outlined", name: option.value, onClick: _this.onClick, size: "medium", color: "primary" }, option.label));
            }))));
    };
    FormControlButtonSwitch.prototype.onClick = function (event) {
        var button = event.currentTarget;
        var option = this.props.options.find(function (o) {
            return o.value === button.name;
        }) || this.props.options[0];
        if (this.props.onClick) {
            this.props.onClick(option);
        }
        this.setState({
            value: option
        });
    };
    return FormControlButtonSwitch;
}(React.Component));
exports.default = FormControlButtonSwitch;
//# sourceMappingURL=FormControlButtonSwitch.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/components/dist/theme/mdb/FormControlButtonSwitch.js
// module id = 2206
// module chunks = 0